// Vendor
import PictureFill from 'picturefill';
import 'mdn-polyfills/Array.from';
import 'mdn-polyfills/Array.prototype.findIndex';
import svg4everybody from 'svg4everybody';
import 'lazysizes';

// Utilities
import ForEach from './utilities/forEach';
import ObjectFit from './utilities/object-fit';
import TenupAccordion from './utilities/tenup-accordion-custom';
import JDRFLoadMore from './utilities/load-more';
import JDRFappendPolyfill from './utilities/append';

// Components
import JDRFAccordion from './components/accordion';
import { localNav } from './components/local-nav';
import SpiritCardGrid from './components/card-grid';
import JDRFUtilityMove from './components/jdrf-utility-move';
import SpiritVerticalNavigation from './components/spirit-vertical-navigation';
import {FixedFlyout} from './components/fixed-flyout';
import CookieNotice from './components/cookie-notice';
import SplashModalCookieNotice from './components/splash-modal-cookie-notice';
import JDRFSpiritModal from './components/jdrf-spirit-modal';

export function TenupInit() {
	svg4everybody();
	PictureFill();
	ForEach.init();
	ObjectFit.init();
	localNav();
	SpiritCardGrid.init();
	TenupAccordion.init();
	JDRFAccordion.init();
	JDRFUtilityMove.init();
	SpiritVerticalNavigation.init();
	FixedFlyout();
	CookieNotice.init();
	SplashModalCookieNotice.init();
	JDRFLoadMore.init();
	JDRFappendPolyfill.init();
	JDRFSpiritModal.init();

	const nav = document.getElementById( 'jdrf-global-main-nav' );
	const body = document.getElementById( 'spirit-shell-main' );
	const $ = window.jQuery;

	if ( nav ) {
		let navLinks = nav.querySelectorAll( '.chapter-home > a' );

		for ( let navLink of Array.from( navLinks ) ) {
			// If on smaller screens & this item is a parent, skip it, as this link toggles children
			if ( 1080 > $( window ).width() && navLink.parentNode.classList.contains( 'menu-item-has-children' ) ) {
				continue;
			}

			navLink.addEventListener( 'click', function( event ) {
				if ( window.localStorage.getItem( 'locationRouter' ) ) {
					event.preventDefault();

					let location = JSON.parse( window.localStorage.getItem( 'locationRouter' ) );
					window.location = location.url || this.getAttribute( 'href' );
				}
			} );
		}
	}

	if ( body ) {
		let bodyLinks = body.querySelectorAll( 'a[aria-label="JDRF Near You"]' );

		for ( let bodyLink of Array.from( bodyLinks ) ) {
			bodyLink.addEventListener( 'click', function( event ) {
				if ( window.localStorage.getItem( 'locationRouter' ) ) {
					event.preventDefault();

					let location = JSON.parse( window.localStorage.getItem( 'locationRouter' ) );
					window.location = location.url || this.getAttribute( 'href' );
				}
			} );
		}
	}
}
